module.exports = __webpack_public_path__ + "static/media/laptop-pencil.dd0d8924.jpg";